import React from "react";
import AMobileListForm from "./aMobileListForm";
import MobileSystemConfigurationDataForm from "./mobileSystemConfigurationDataForm";
import MobileCancelButton from "../button/mobileCancelButton";
import SystemConfigurationAccess from "../../../services/database/systemConfigurationAccess";
import {systemConfigurationTable} from "../../../config.json";

class MobileSystemConfigurationListForm extends AMobileListForm {
    constructor(props) {
        super(props);
    }

    availableModes = {
        list: true,
        show: true,
        edit: true
    };
    tableDefinition = [
        // { header: "Id", field: "id", width: 75 },
        {header: "Name", field: "name"},
        {
            header: "Wert",
            field: "value"
        }
    ];

    configurations = {
        mandatoryNumber: "",
        deviceSerialNumber: "",
        url: ""
    };

    renderBackToMenuButton = () => {
        if (
            this.props.configurations &&
            this.props.configurations.mandatoryNumber === "/login"
        ) {
            return (
                <div className="btn-group mr-2" role="group">
                    <MobileCancelButton
                        onClick={() => {
                            this.props.handleSetConfigurations(this.configurations);
                        }}
                        // title={itButton.title}
                        title={{
                            text: "Hauptmenü",
                            style: {}
                        }}
                    />
                </div>
            );
        } else {
            return (
                <div className="btn-group mr-2" role="group">
                    <MobileCancelButton
                        onClick={() => {
                            this.clickButton(this.onFieldCancel);
                        }}
                        // title={itButton.title}
                        title={{
                            text: "Hauptmenü",
                            style: {}
                        }}
                    />
                </div>
            );
        }
    };

    getMobileDataForm = () => {
        return <MobileSystemConfigurationDataForm/>;
    };

    loadAllData = async () => {
        let dataList = [];
        const {database} = this.props;
        if (database) {
            this.recordList = await SystemConfigurationAccess.getAll(
                database,
                systemConfigurationTable
            );
            if (this.recordList && this.recordList.length > 0) {
                for (const record of this.recordList) {
                    dataList.push({
                        id: record.id,
                        name: record.name,
                        value: record.value
                    });

                    this.configurations[record.name] = record.value;
                }
            }
        }
        this.setState({dataList});
    };

    update = async (id, data) => {
        const {database} = this.props;
        if (database) {
            await SystemConfigurationAccess.updateById(
                database,
                systemConfigurationTable,
                id,
                data
            );
        }
        await this.loadAllData();

        this.props.handleSetConfigurations({
            mandatoryNumber: "/login",
            deviceSerialNumber: ""
        });

        this.setListMode();
    };
}

export default MobileSystemConfigurationListForm;
